import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { useListagemContext } from 'context/ListagemContext';
import { GerarReembolsoStatusChip } from 'pages/financeiro/reembolso/gerar-reembolso/components';
import { useGerarReembolsoContext } from 'pages/financeiro/reembolso/gerar-reembolso/contexts';
import { useQueryReembolso } from 'pages/financeiro/reembolso/gerar-reembolso/hooks';
import { Reembolso } from 'pages/financeiro/reembolso/gerar-reembolso/types';
import { brlDecimal, brlPrice } from 'util/format';

/**
 * Retorna array com os dados formatados para o grid.
 */
const getRows = (data: Reembolso[] | undefined): GridRowsProp => {
    const list = data;

    if (Array.isArray(list) && list.length) {
        return list.map((item) => ({
            id: `${item.idPromocao}-${item.cdApuracaoFormatado}`,
            idPromocao: item.idPromocao,
            dsPromocao: item.dsPromocao,
            cdApuracao: item.cdApuracao,
            cdApuracaoFormatado: item.cdApuracaoFormatado,
            vlTotalBruto: item.vlTotalBruto,
            vlDesconto: item.vlDesconto,
            peReembolso: item.peReembolso,
            vlTotalLiquido: item.vlTotalLiquido,
            vlReembolso: item.vlReembolso,
            idStatusApuracao: item.idStatusApuracao,
            dsStatusApuracao: item.dsStatusApuracao,
        }));
    }

    return [];
};

const columns: GridColDef[] = [
    { field: 'idPromocao', headerName: 'Código da promoção', flex: 1, type: 'number' },
    { field: 'dsPromocao', headerName: 'Promocão/campanha', flex: 2 },
    { field: 'cdApuracaoFormatado', headerName: 'Código da apuração', flex: 1 },
    { field: 'vlTotalBruto', headerName: 'Total bruto', flex: 1, type: 'number', valueFormatter: (value) => brlPrice(value) },
    { field: 'vlDesconto', headerName: 'Desconto item', flex: 1, type: 'number', valueFormatter: (value) => brlPrice(value) },
    { field: 'peReembolso', headerName: 'Fator reembolso', flex: 1, type: 'number', valueFormatter: (value) => brlDecimal(value) },
    { field: 'vlTotalLiquido', headerName: 'Total líquido', flex: 1, type: 'number', valueFormatter: (value) => brlPrice(value) },
    { field: 'vlReembolso', headerName: 'Valor reembolso', flex: 1, type: 'number', valueFormatter: (value) => brlPrice(value) },
    {
        field: 'acoes',
        align: 'center',
        headerAlign: 'center',
        headerName: 'Status',
        width: 190,
        renderCell: ({ row }) => <GerarReembolsoStatusChip idStatusApuracao={row.idStatusApuracao} dsStatusApuracao={row.dsStatusApuracao} />,
    },
];

export function GerarReembolsoGrid() {
    const { refGrid, setFgTodasPromocoes, selectedPromocoes, setSelectedPromocoes } = useGerarReembolsoContext();
    const { data, refetch, isFetching } = useQueryReembolso();
    const { getFilterValues } = useListagemContext();
    const { idStatusApuracao } = getFilterValues();
    const isPendente = idStatusApuracao?.statusApuracaoEnum === 'PENDENTE';

    return (
        <PanelGrid
            ref={refGrid}
            checkboxSelection={isPendente}
            rows={getRows(data?.data)}
            reload={refetch}
            columns={columns}
            remote={false}
            loading={isFetching}
            selectionModel={selectedPromocoes}
            onClickRow={(selection) => {
                setSelectedPromocoes(selection);

                setFgTodasPromocoes(selection.ids.size === data?.total);
            }}
        />
    );
}
